import _ from 'lodash'

import * as define from '@/define'
import common from '@/utils/common'

export default {
  methods: {
    /**
     * 表示するデータを返却します。
     * @param {Object} obj
     * @param {String} path
     * @param {String} colsep
     * @param {String} codeName
     * @param {String} siteCode
    */
    $_mixin_getData (obj, path, colsep = '', codeName = null, { siteCode } = {}) {
      if (!path) return
      let result = ''
      if (Array.isArray(path)) {
        path.forEach((p, i) => {
          if (i > 0) result += colsep
          result += this.$_mixin_pipeCheck(obj, p, colsep, codeName, { siteCode: siteCode })
        })
      } else {
        result = this.$_mixin_pipeCheck(obj, path, colsep, codeName, { siteCode: siteCode })
      }
      return result
    },
    /**
     * | 区切りで配列を処理します。
     * @param {Object} obj
     * @param {String} path
     * @param {String} colsep
     * @param {String} codeName
     * @param {String} siteCode
    */
    $_mixin_pipeCheck (obj, path, colsep, codeName, { siteCode } = {}) {
      let result = ''
      if (typeof path === 'function') {
        path = path(obj)
      }
      const iof = path.indexOf('|')
      if (iof >= 0) {
        let values = common.getValueByPath(obj, path.substr(0, iof))
        _.forEach(values, (v, i) => {
          if (i > 0) result += colsep
          result += this.$_mixin_pipeCheck(v, path.substr(iof + 1), colsep, codeName, { siteCode: siteCode })
        })
      } else {
        if (codeName) {
          result = this.$_mixin_getCodeName(common.getValueByPath(obj, path), codeName, { siteCode: siteCode })
        } else {
          result = common.getValueByPath(obj, path)
        }
      }
      return result
    },
    /**
     * コード名称を返却する.
     * @param {String} codeName
     * @param {*} code
     * @param {String} siteCode
     * @return {String} 名称
     */
    $_mixin_getCodeName: function (code, codeName, { siteCode } = {}) {
      if (!codeName) return code
      if (code == null || code === '') return code

      // function の場合
      if (typeof codeName === 'function') {
        return codeName(code)
      }
      // sites の場合
      if (codeName === 'sites') {
        let site = this.$store.state.sites.find((site) => {
          return site.code === code
        })
        return site ? code + ': ' + site.name : code
      }
      // その他
      const serviceSiteConfigs = this.$store.state.serviceSiteConfigs
      const kv = common.getValueByPath(serviceSiteConfigs, codeName)
      return _.get(kv, `${code}.${siteCode}.abbr`) ||
        _.get(kv, `${code}.abbr`) ||
        code
    },
    /**
     * selectBox の option を設定します。
     * @param {String} selectCode
     * @param {String} siteCode
     * @return {Object}
     * TODO: サイト固有の値がある場合にサイトコード null の値もセットしている
     * サイト固有の値がある場合は null はセットしないようにする
     * getCodeName も同じにしたほうがいいと思う
     */
    $_mixin_selectOptions: function (selectCode, { siteCode } = {}) {
      // sites の場合
      if (selectCode === 'sites') {
        return this.$store.state.sites
      }

      const serviceSiteConfigs = this.$store.state.serviceSiteConfigs
      const kv = common.getValueByPath(serviceSiteConfigs, selectCode)
      let result
      if (kv) {
        // サイト単位のserviceSiteConfigを取得
        result = _.chain(kv)
          .entries()
          .reduce((acc, [code, value]) => {
            if (siteCode in value) {
              acc.push({ code: code, name: value[siteCode].abbr, order: value[siteCode].order })
            }
            return acc
          }, [])
          .value()
        if (result == null || result.length === 0) {
          // サイト単位のserviceSiteConfigがない場合、共通のserviceSiteConfigを取得
          result = _.chain(kv)
            .entries()
            .reduce((acc, [code, value]) => {
              if ('abbr' in value && 'order' in value) {
                acc.push({ code: code, name: value.abbr, order: value.order })
              }
              return acc
            }, [])
            .value()
        }
        result = result.sort((a, b) => {
          if (a.order > b.order) {
            return 1
          } else if (a.order < b.order) {
            return -1
          } else {
            return 0
          }
        })
      }
      return result
    },
    /**
     * 更新処理を行います。(v-model を利用できないため、bind した値を強制的に更新する)
     * @param {*} val 値
     * @param {Object} obj state
     * @param {String} path state の property
     * @param {Boolean} forceNumber val を強制的に Number 型にする場合 true
     *  forceNumber はプロパティの type==='Number' の結果がセットされている
     */
    $_mixin_updateValue: function (val, obj, path, forceNumber = false) {
      let i = path.indexOf('.')
      if (i < 0) {
        if (typeof obj[path] === 'number' || forceNumber) {
        // 元の値が数値型、又は forceNumber が true
          if (val === '' || val == null) {
          // 空文字,NULLの場合、空文字を設定
            obj[path] = ''
          } else {
            // それ以外は数値型に変換する
            // ※ element-ui の select option 値(サービスサイト)が文字列のため、数値側の項目は数値側に変換する必要がある
            let num = Number(val)
            // 数値でない場合は値をそのまま設定
            obj[path] = isNaN(num) ? val : num
          }
        } else if (typeof obj[path] === 'boolean') {
          obj[path] = val === 'false' ? false : Boolean(val)
        } else {
          obj[path] = val
        }
        return
      }
      if (obj[path.substr(0, i)] == null) {
        this.$set(obj, path.substr(0, i), {})
      }
      return this.$_mixin_updateValue(
        val, obj[path.substr(0, i)], path.substr(i + 1), forceNumber)
    },
    /**
     * 受け取った Function を実行します。
     * @param {*} context
     */
    $_mixin_executeFunction: function (context, callBack) {
      return callBack(context)
    },
    /**
     * 一覧の配列 index、戻るボタンのパスのコミット
     * @param {Number} index 配列のindex
     * @param {Number} mode 画面モード 既定は 0
     */
    $_mixin_onLinkClick: function (index, storePath, mode = define.MODE.NORMAL) {
      const listIndex = storePath + '/listIndex'
      const modeStorePath = storePath + '/mode'
      this.$store.dispatch({
        type: 'set',
        states: {
          [listIndex]: index,
          [modeStorePath]: mode
        }
      })
    },
    /**
     * list から condition と一致するデータを検索し、index を返却する.
     * @param {Array} list
     * @param {Object} condition 検索条件. path と value のペア.
     */
    $_mixin_findIndex (list, condition) {
      let _condition = _.entries(condition)
      return _.findIndex(list, (val) => {
        for (let i = 0; i < _condition.length; i++) {
          if (_.get(val, _condition[i][0]) !== _condition[i][1]) {
            return false
          }
        }
        return true
      })
    },
    /**
     * 条件に合致する場合、スタイルを返却する
     *  element-ui el-table custom-cell-style 専用関数
     * @param {Object} r rowデータ element-ui から受け取る情報
     * @param {String} customCellStyle カスタムセルスタイル (サービスサイト設定)
     * @param {String} path rowデータから変更対象のセルかを判定するために取り出す際のパス情報
     *  default: '', sample: 'node.'
     * @returns {String} スタイル
     */
    $_mixin_cellStyle (r, customCellStyle, path = '') {
      if ((customCellStyle || '') === '') {
      // カスタムセルスタイル設定がない場合は終了
        return null
      }
      if ((r.column.property || '') === '') {
      // el-table の cellStyle の引数(row)に property がない場合は終了
        return null
      }
      // カスタムセルスタイルを展開し、条件が合致する場合はスタイルを返却
      for (const k of Object.keys(customCellStyle)) {
        if (r.column.property === `${path}${k}`) {
          const f = new Function('r', customCellStyle[k].v[0])
          return f(r)
        }
      }
      return null
    }
  }
}
